import React from 'react';
import SaleProduct from 'components/Tvendo/Sale/Operations/SaleProduct/List.js';

export default function () {
  return <SaleProduct />;
}
